import { partyFileTitle } from '@/lib/agreement/filters';

export default {
	methods: {
		filename(routeQuery) {
			const { partner1, partner2 } = this.agreement || {};
			const partner1Last = partner1?.name?.last || '';
			const partner2Last = partner2?.name?.last || '';
			let resultName = 'Separation Agreement';

			const named = partner1Last && partner2Last;

			if (routeQuery?.download === 'summary') {
				resultName = named
					? partyFileTitle(partner1Last, partner2Last, 'Separation Agreement Summary')
					: 'Separation Agreement Summary';
			} else if (routeQuery?.download === 'property-schedule') {
				resultName = named
					? partyFileTitle(partner1Last, partner2Last, 'Property Schedule')
					: 'Property Schedule';
			} else if (named) {
				resultName = partyFileTitle(partner1Last, partner2Last, 'Separation Agreement');
			}

			return resultName;
		},
	},
};
